import { render, staticRenderFns } from "./SchemaTypeList.vue?vue&type=template&id=601f68ba&"
import script from "./SchemaTypeList.vue?vue&type=script&lang=js&"
export * from "./SchemaTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports